module.exports = __webpack_public_path__ + "static/media/icon-menu-more.848bb107.svg";